export default __webpack_public_path__ + "static/68971-c81c2fdea879d6e0d5af4e1653e34758.jpg";